module.exports = __webpack_public_path__ + "img/back.edff3e15.svg";